// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"9b6626b6","787":"724b0e9b"}[chunkId] + ".chunk.js";
};